/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  AutobasLoginDto,
  AutobasLoginLinkDto,
  CreateDeliveryConditionReasonModel,
  DeliveryConditionReasonAdminDto,
  DeliveryConditionTierDto2,
  ExpenseTypeThresholdDto,
  GlobalSettingModel,
  GlobalSettingsGetSettings200Five,
  GlobalSettingsGetSettings200Four,
  GlobalSettingsGetSettings200One,
  GlobalSettingsGetSettings200Three,
  GlobalSettingsGetSettings200Two,
  HomeAnchorMappingApplyRequestDTO,
  HomeAnchorMappingApplyResultDTO,
  HomeAnchorMappingPreviewDTO,
  InvoiceExtraDefaultValueDto,
  ProblemDetails,
  UpdateDeliveryConditionReasonModel,
  UpdateDeliveryConditionTierModel,
  UpdateExpenseTypeThresholdModel,
  UpdateInvoiceExtraDefaultValueModel,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useGlobalSettingsUpdateSettingHook = () => {
  const globalSettingsUpdateSetting = useCustomInstance<unknown>();

  return useCallback(
    (globalSettingModel: GlobalSettingModel) => {
      return globalSettingsUpdateSetting({
        url: `/api/GlobalSettings/UpdateSetting`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: globalSettingModel,
      });
    },
    [globalSettingsUpdateSetting]
  );
};

export const useGlobalSettingsUpdateSettingMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>,
    TError,
    { data: GlobalSettingModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>,
  TError,
  { data: GlobalSettingModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsUpdateSetting = useGlobalSettingsUpdateSettingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>,
    { data: GlobalSettingModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsUpdateSetting(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsUpdateSettingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>
>;
export type GlobalSettingsUpdateSettingMutationBody = GlobalSettingModel;
export type GlobalSettingsUpdateSettingMutationError = ProblemDetails;

export const useGlobalSettingsUpdateSetting = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>,
    TError,
    { data: GlobalSettingModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useGlobalSettingsUpdateSettingHook>>>,
  TError,
  { data: GlobalSettingModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsUpdateSettingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsGetSettingsHook = () => {
  const globalSettingsGetSettings = useCustomInstance<
    | GlobalSettingsGetSettings200One
    | GlobalSettingsGetSettings200Two
    | GlobalSettingsGetSettings200Three
    | GlobalSettingsGetSettings200Four
    | GlobalSettingsGetSettings200Five
  >();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetSettings({
        url: `/api/GlobalSettings/GetSettings`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetSettings]
  );
};

export const getGlobalSettingsGetSettingsQueryKey = () => {
  return [`/api/GlobalSettings/GetSettings`] as const;
};

export const useGlobalSettingsGetSettingsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGlobalSettingsGetSettingsQueryKey();

  const globalSettingsGetSettings = useGlobalSettingsGetSettingsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>>
  > = ({ signal }) => globalSettingsGetSettings(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>>
>;
export type GlobalSettingsGetSettingsQueryError = unknown;

export const useGlobalSettingsGetSettings = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetSettingsHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGlobalSettingsGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsGetAutobasLoginHook = () => {
  const globalSettingsGetAutobasLogin = useCustomInstance<AutobasLoginDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetAutobasLogin({
        url: `/api/GlobalSettings/GetAutobasLogin`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetAutobasLogin]
  );
};

export const getGlobalSettingsGetAutobasLoginQueryKey = () => {
  return [`/api/GlobalSettings/GetAutobasLogin`] as const;
};

export const useGlobalSettingsGetAutobasLoginQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGlobalSettingsGetAutobasLoginQueryKey();

  const globalSettingsGetAutobasLogin = useGlobalSettingsGetAutobasLoginHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>>
  > = ({ signal }) => globalSettingsGetAutobasLogin(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetAutobasLoginQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>>
>;
export type GlobalSettingsGetAutobasLoginQueryError = unknown;

export const useGlobalSettingsGetAutobasLogin = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useGlobalSettingsGetAutobasLoginQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsGetAutobasLoginLinkHook = () => {
  const globalSettingsGetAutobasLoginLink =
    useCustomInstance<AutobasLoginLinkDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetAutobasLoginLink({
        url: `/api/GlobalSettings/GetAutobasLoginLink`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetAutobasLoginLink]
  );
};

export const getGlobalSettingsGetAutobasLoginLinkQueryKey = () => {
  return [`/api/GlobalSettings/GetAutobasLoginLink`] as const;
};

export const useGlobalSettingsGetAutobasLoginLinkQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGlobalSettingsGetAutobasLoginLinkQueryKey();

  const globalSettingsGetAutobasLoginLink =
    useGlobalSettingsGetAutobasLoginLinkHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
    >
  > = ({ signal }) => globalSettingsGetAutobasLoginLink(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetAutobasLoginLinkQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
  >
>;
export type GlobalSettingsGetAutobasLoginLinkQueryError = unknown;

export const useGlobalSettingsGetAutobasLoginLink = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsGetAutobasLoginLinkHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetAutobasLoginLinkQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsGetSpeedLimitServiceNamesHook = () => {
  const globalSettingsGetSpeedLimitServiceNames = useCustomInstance<string[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetSpeedLimitServiceNames({
        url: `/api/GlobalSettings/GetSpeedLimitServiceNames`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetSpeedLimitServiceNames]
  );
};

export const getGlobalSettingsGetSpeedLimitServiceNamesQueryKey = () => {
  return [`/api/GlobalSettings/GetSpeedLimitServiceNames`] as const;
};

export const useGlobalSettingsGetSpeedLimitServiceNamesQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsGetSpeedLimitServiceNamesQueryKey();

  const globalSettingsGetSpeedLimitServiceNames =
    useGlobalSettingsGetSpeedLimitServiceNamesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
      >
    >
  > = ({ signal }) => globalSettingsGetSpeedLimitServiceNames(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetSpeedLimitServiceNamesQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
    >
  >
>;
export type GlobalSettingsGetSpeedLimitServiceNamesQueryError = unknown;

export const useGlobalSettingsGetSpeedLimitServiceNames = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetSpeedLimitServiceNamesHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetSpeedLimitServiceNamesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsGetExpenseTypeThresholdsHook = () => {
  const globalSettingsGetExpenseTypeThresholds =
    useCustomInstance<ExpenseTypeThresholdDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetExpenseTypeThresholds({
        url: `/api/GlobalSettings/GetExpenseTypeThresholds`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetExpenseTypeThresholds]
  );
};

export const getGlobalSettingsGetExpenseTypeThresholdsQueryKey = () => {
  return [`/api/GlobalSettings/GetExpenseTypeThresholds`] as const;
};

export const useGlobalSettingsGetExpenseTypeThresholdsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsGetExpenseTypeThresholdsQueryKey();

  const globalSettingsGetExpenseTypeThresholds =
    useGlobalSettingsGetExpenseTypeThresholdsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>
      >
    >
  > = ({ signal }) => globalSettingsGetExpenseTypeThresholds(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetExpenseTypeThresholdsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>>
  >
>;
export type GlobalSettingsGetExpenseTypeThresholdsQueryError = unknown;

export const useGlobalSettingsGetExpenseTypeThresholds = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetExpenseTypeThresholdsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetExpenseTypeThresholdsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsUpdateExpenseTypeThresholdHook = () => {
  const globalSettingsUpdateExpenseTypeThreshold = useCustomInstance<void>();

  return useCallback(
    (updateExpenseTypeThresholdModel: UpdateExpenseTypeThresholdModel) => {
      return globalSettingsUpdateExpenseTypeThreshold({
        url: `/api/GlobalSettings/UpdateExpenseTypeThreshold`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateExpenseTypeThresholdModel,
      });
    },
    [globalSettingsUpdateExpenseTypeThreshold]
  );
};

export const useGlobalSettingsUpdateExpenseTypeThresholdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
      >
    >,
    TError,
    { data: UpdateExpenseTypeThresholdModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
    >
  >,
  TError,
  { data: UpdateExpenseTypeThresholdModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsUpdateExpenseTypeThreshold =
    useGlobalSettingsUpdateExpenseTypeThresholdHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
      >
    >,
    { data: UpdateExpenseTypeThresholdModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsUpdateExpenseTypeThreshold(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsUpdateExpenseTypeThresholdMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
      >
    >
  >;
export type GlobalSettingsUpdateExpenseTypeThresholdMutationBody =
  UpdateExpenseTypeThresholdModel;
export type GlobalSettingsUpdateExpenseTypeThresholdMutationError = unknown;

export const useGlobalSettingsUpdateExpenseTypeThreshold = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
      >
    >,
    TError,
    { data: UpdateExpenseTypeThresholdModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateExpenseTypeThresholdHook>
    >
  >,
  TError,
  { data: UpdateExpenseTypeThresholdModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsUpdateExpenseTypeThresholdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsGetInvoiceExtraDefaultValuesHook = () => {
  const globalSettingsGetInvoiceExtraDefaultValues =
    useCustomInstance<InvoiceExtraDefaultValueDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetInvoiceExtraDefaultValues({
        url: `/api/GlobalSettings/GetInvoiceExtraDefaultValues`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetInvoiceExtraDefaultValues]
  );
};

export const getGlobalSettingsGetInvoiceExtraDefaultValuesQueryKey = () => {
  return [`/api/GlobalSettings/GetInvoiceExtraDefaultValues`] as const;
};

export const useGlobalSettingsGetInvoiceExtraDefaultValuesQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsGetInvoiceExtraDefaultValuesQueryKey();

  const globalSettingsGetInvoiceExtraDefaultValues =
    useGlobalSettingsGetInvoiceExtraDefaultValuesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
      >
    >
  > = ({ signal }) => globalSettingsGetInvoiceExtraDefaultValues(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetInvoiceExtraDefaultValuesQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
    >
  >
>;
export type GlobalSettingsGetInvoiceExtraDefaultValuesQueryError = unknown;

export const useGlobalSettingsGetInvoiceExtraDefaultValues = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetInvoiceExtraDefaultValuesHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetInvoiceExtraDefaultValuesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsUpdateInvoiceExtraDefaultValueHook = () => {
  const globalSettingsUpdateInvoiceExtraDefaultValue =
    useCustomInstance<void>();

  return useCallback(
    (
      updateInvoiceExtraDefaultValueModel: UpdateInvoiceExtraDefaultValueModel
    ) => {
      return globalSettingsUpdateInvoiceExtraDefaultValue({
        url: `/api/GlobalSettings/UpdateInvoiceExtraDefaultValue`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateInvoiceExtraDefaultValueModel,
      });
    },
    [globalSettingsUpdateInvoiceExtraDefaultValue]
  );
};

export const useGlobalSettingsUpdateInvoiceExtraDefaultValueMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
      >
    >,
    TError,
    { data: UpdateInvoiceExtraDefaultValueModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
    >
  >,
  TError,
  { data: UpdateInvoiceExtraDefaultValueModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsUpdateInvoiceExtraDefaultValue =
    useGlobalSettingsUpdateInvoiceExtraDefaultValueHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
      >
    >,
    { data: UpdateInvoiceExtraDefaultValueModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsUpdateInvoiceExtraDefaultValue(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsUpdateInvoiceExtraDefaultValueMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
      >
    >
  >;
export type GlobalSettingsUpdateInvoiceExtraDefaultValueMutationBody =
  UpdateInvoiceExtraDefaultValueModel;
export type GlobalSettingsUpdateInvoiceExtraDefaultValueMutationError = unknown;

export const useGlobalSettingsUpdateInvoiceExtraDefaultValue = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
      >
    >,
    TError,
    { data: UpdateInvoiceExtraDefaultValueModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateInvoiceExtraDefaultValueHook>
    >
  >,
  TError,
  { data: UpdateInvoiceExtraDefaultValueModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsUpdateInvoiceExtraDefaultValueMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsGetDeliveryConditionTiersHook = () => {
  const globalSettingsGetDeliveryConditionTiers =
    useCustomInstance<DeliveryConditionTierDto2[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetDeliveryConditionTiers({
        url: `/api/GlobalSettings/GetDeliveryConditionTiers`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetDeliveryConditionTiers]
  );
};

export const getGlobalSettingsGetDeliveryConditionTiersQueryKey = () => {
  return [`/api/GlobalSettings/GetDeliveryConditionTiers`] as const;
};

export const useGlobalSettingsGetDeliveryConditionTiersQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsGetDeliveryConditionTiersQueryKey();

  const globalSettingsGetDeliveryConditionTiers =
    useGlobalSettingsGetDeliveryConditionTiersHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
      >
    >
  > = ({ signal }) => globalSettingsGetDeliveryConditionTiers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetDeliveryConditionTiersQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
    >
  >
>;
export type GlobalSettingsGetDeliveryConditionTiersQueryError = unknown;

export const useGlobalSettingsGetDeliveryConditionTiers = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionTiersHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetDeliveryConditionTiersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsUpdateDeliveryConditionTierHook = () => {
  const globalSettingsUpdateDeliveryConditionTier = useCustomInstance<void>();

  return useCallback(
    (updateDeliveryConditionTierModel: UpdateDeliveryConditionTierModel) => {
      return globalSettingsUpdateDeliveryConditionTier({
        url: `/api/GlobalSettings/UpdateDeliveryConditionTier`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateDeliveryConditionTierModel,
      });
    },
    [globalSettingsUpdateDeliveryConditionTier]
  );
};

export const useGlobalSettingsUpdateDeliveryConditionTierMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
      >
    >,
    TError,
    { data: UpdateDeliveryConditionTierModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
    >
  >,
  TError,
  { data: UpdateDeliveryConditionTierModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsUpdateDeliveryConditionTier =
    useGlobalSettingsUpdateDeliveryConditionTierHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
      >
    >,
    { data: UpdateDeliveryConditionTierModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsUpdateDeliveryConditionTier(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsUpdateDeliveryConditionTierMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
      >
    >
  >;
export type GlobalSettingsUpdateDeliveryConditionTierMutationBody =
  UpdateDeliveryConditionTierModel;
export type GlobalSettingsUpdateDeliveryConditionTierMutationError = unknown;

export const useGlobalSettingsUpdateDeliveryConditionTier = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
      >
    >,
    TError,
    { data: UpdateDeliveryConditionTierModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionTierHook>
    >
  >,
  TError,
  { data: UpdateDeliveryConditionTierModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsUpdateDeliveryConditionTierMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsGetDeliveryConditionReasonsHook = () => {
  const globalSettingsGetDeliveryConditionReasons =
    useCustomInstance<DeliveryConditionReasonAdminDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsGetDeliveryConditionReasons({
        url: `/api/GlobalSettings/GetDeliveryConditionReasons`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsGetDeliveryConditionReasons]
  );
};

export const getGlobalSettingsGetDeliveryConditionReasonsQueryKey = () => {
  return [`/api/GlobalSettings/GetDeliveryConditionReasons`] as const;
};

export const useGlobalSettingsGetDeliveryConditionReasonsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsGetDeliveryConditionReasonsQueryKey();

  const globalSettingsGetDeliveryConditionReasons =
    useGlobalSettingsGetDeliveryConditionReasonsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
      >
    >
  > = ({ signal }) => globalSettingsGetDeliveryConditionReasons(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsGetDeliveryConditionReasonsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
    >
  >
>;
export type GlobalSettingsGetDeliveryConditionReasonsQueryError = unknown;

export const useGlobalSettingsGetDeliveryConditionReasons = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsGetDeliveryConditionReasonsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsGetDeliveryConditionReasonsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsCreateDeliveryConditionReasonHook = () => {
  const globalSettingsCreateDeliveryConditionReason =
    useCustomInstance<DeliveryConditionReasonAdminDto>();

  return useCallback(
    (
      createDeliveryConditionReasonModel: CreateDeliveryConditionReasonModel
    ) => {
      return globalSettingsCreateDeliveryConditionReason({
        url: `/api/GlobalSettings/CreateDeliveryConditionReason`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDeliveryConditionReasonModel,
      });
    },
    [globalSettingsCreateDeliveryConditionReason]
  );
};

export const useGlobalSettingsCreateDeliveryConditionReasonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
      >
    >,
    TError,
    { data: CreateDeliveryConditionReasonModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
    >
  >,
  TError,
  { data: CreateDeliveryConditionReasonModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsCreateDeliveryConditionReason =
    useGlobalSettingsCreateDeliveryConditionReasonHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
      >
    >,
    { data: CreateDeliveryConditionReasonModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsCreateDeliveryConditionReason(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsCreateDeliveryConditionReasonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
      >
    >
  >;
export type GlobalSettingsCreateDeliveryConditionReasonMutationBody =
  CreateDeliveryConditionReasonModel;
export type GlobalSettingsCreateDeliveryConditionReasonMutationError = unknown;

export const useGlobalSettingsCreateDeliveryConditionReason = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
      >
    >,
    TError,
    { data: CreateDeliveryConditionReasonModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsCreateDeliveryConditionReasonHook>
    >
  >,
  TError,
  { data: CreateDeliveryConditionReasonModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsCreateDeliveryConditionReasonMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsUpdateDeliveryConditionReasonHook = () => {
  const globalSettingsUpdateDeliveryConditionReason = useCustomInstance<void>();

  return useCallback(
    (
      updateDeliveryConditionReasonModel: UpdateDeliveryConditionReasonModel
    ) => {
      return globalSettingsUpdateDeliveryConditionReason({
        url: `/api/GlobalSettings/UpdateDeliveryConditionReason`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateDeliveryConditionReasonModel,
      });
    },
    [globalSettingsUpdateDeliveryConditionReason]
  );
};

export const useGlobalSettingsUpdateDeliveryConditionReasonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
      >
    >,
    TError,
    { data: UpdateDeliveryConditionReasonModel },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
    >
  >,
  TError,
  { data: UpdateDeliveryConditionReasonModel },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsUpdateDeliveryConditionReason =
    useGlobalSettingsUpdateDeliveryConditionReasonHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
      >
    >,
    { data: UpdateDeliveryConditionReasonModel }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsUpdateDeliveryConditionReason(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsUpdateDeliveryConditionReasonMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
      >
    >
  >;
export type GlobalSettingsUpdateDeliveryConditionReasonMutationBody =
  UpdateDeliveryConditionReasonModel;
export type GlobalSettingsUpdateDeliveryConditionReasonMutationError = unknown;

export const useGlobalSettingsUpdateDeliveryConditionReason = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
      >
    >,
    TError,
    { data: UpdateDeliveryConditionReasonModel },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useGlobalSettingsUpdateDeliveryConditionReasonHook>
    >
  >,
  TError,
  { data: UpdateDeliveryConditionReasonModel },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsUpdateDeliveryConditionReasonMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useGlobalSettingsPreviewHomeAnchorMappingHook = () => {
  const globalSettingsPreviewHomeAnchorMapping =
    useCustomInstance<HomeAnchorMappingPreviewDTO>();

  return useCallback(
    (signal?: AbortSignal) => {
      return globalSettingsPreviewHomeAnchorMapping({
        url: `/api/GlobalSettings/PreviewHomeAnchorMapping`,
        method: 'GET',
        signal,
      });
    },
    [globalSettingsPreviewHomeAnchorMapping]
  );
};

export const getGlobalSettingsPreviewHomeAnchorMappingQueryKey = () => {
  return [`/api/GlobalSettings/PreviewHomeAnchorMapping`] as const;
};

export const useGlobalSettingsPreviewHomeAnchorMappingQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGlobalSettingsPreviewHomeAnchorMappingQueryKey();

  const globalSettingsPreviewHomeAnchorMapping =
    useGlobalSettingsPreviewHomeAnchorMappingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>
      >
    >
  > = ({ signal }) => globalSettingsPreviewHomeAnchorMapping(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GlobalSettingsPreviewHomeAnchorMappingQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>>
  >
>;
export type GlobalSettingsPreviewHomeAnchorMappingQueryError = unknown;

export const useGlobalSettingsPreviewHomeAnchorMapping = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useGlobalSettingsPreviewHomeAnchorMappingHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useGlobalSettingsPreviewHomeAnchorMappingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useGlobalSettingsApplyHomeAnchorMappingHook = () => {
  const globalSettingsApplyHomeAnchorMapping =
    useCustomInstance<HomeAnchorMappingApplyResultDTO>();

  return useCallback(
    (homeAnchorMappingApplyRequestDTO: HomeAnchorMappingApplyRequestDTO) => {
      return globalSettingsApplyHomeAnchorMapping({
        url: `/api/GlobalSettings/ApplyHomeAnchorMapping`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: homeAnchorMappingApplyRequestDTO,
      });
    },
    [globalSettingsApplyHomeAnchorMapping]
  );
};

export const useGlobalSettingsApplyHomeAnchorMappingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
    >,
    TError,
    { data: HomeAnchorMappingApplyRequestDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
  >,
  TError,
  { data: HomeAnchorMappingApplyRequestDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const globalSettingsApplyHomeAnchorMapping =
    useGlobalSettingsApplyHomeAnchorMappingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
    >,
    { data: HomeAnchorMappingApplyRequestDTO }
  > = (props) => {
    const { data } = props ?? {};

    return globalSettingsApplyHomeAnchorMapping(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GlobalSettingsApplyHomeAnchorMappingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
  >
>;
export type GlobalSettingsApplyHomeAnchorMappingMutationBody =
  HomeAnchorMappingApplyRequestDTO;
export type GlobalSettingsApplyHomeAnchorMappingMutationError = unknown;

export const useGlobalSettingsApplyHomeAnchorMapping = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
    >,
    TError,
    { data: HomeAnchorMappingApplyRequestDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useGlobalSettingsApplyHomeAnchorMappingHook>>
  >,
  TError,
  { data: HomeAnchorMappingApplyRequestDTO },
  TContext
> => {
  const mutationOptions =
    useGlobalSettingsApplyHomeAnchorMappingMutationOptions(options);

  return useMutation(mutationOptions);
};
